export default "__VITE_ASSET__CwvNUlIa__"